// Design Ref: §4.4 WinRateBar — CSS horizontal 월별 승률
// Plan SC: FR-03 월별 승률 표시
import React from 'react';

/**
 * Props:
 *  - data: [{ label, wins, losses, total, rate }]
 *  - title?
 *  - maxRows? (default 12)
 *  - winColor? '#34d399'
 *  - lossColor? '#fb7185'
 */
export default function WinRateBar({
  data = [],
  title,
  maxRows = 12,
  winColor = '#34d399',
  lossColor = '#fb7185',
}) {
  if (!data.length) {
    return <EmptyBlock title={title} msg="데이터 없음" />;
  }
  const filtered = data.filter(d => d.total > 0).slice(-maxRows);
  if (!filtered.length) {
    return <EmptyBlock title={title} msg="매도 거래 없음" />;
  }

  return (
    <div style={{ background: 'var(--bg-table)', border: '1px solid var(--border-light)', borderRadius: 12, padding: '14px 16px' }}>
      {title && <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 10, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{title}</div>}
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {filtered.map(d => {
          const winPct = d.total > 0 ? (d.wins / d.total) * 100 : 0;
          const lossPct = 100 - winPct;
          return (
            <div key={d.label} style={{ display: 'grid', gridTemplateColumns: '64px 1fr 56px', gap: 8, alignItems: 'center', fontSize: 11 }}>
              <div style={{ fontFamily: "'DM Mono', monospace", color: 'var(--text-sub)', fontSize: 10 }}>{d.label}</div>
              <div style={{ display: 'flex', height: 16, borderRadius: 3, overflow: 'hidden', background: 'var(--border-light)' }} title={`${d.wins}승 ${d.losses}패`}>
                <div style={{ width: `${winPct}%`, background: winColor, transition: 'width 0.3s' }} />
                <div style={{ width: `${lossPct}%`, background: lossColor, transition: 'width 0.3s' }} />
              </div>
              <div style={{ fontFamily: "'DM Mono', monospace", color: d.rate >= 50 ? winColor : lossColor, fontSize: 11, textAlign: 'right' }}>
                {d.rate !== null ? d.rate.toFixed(0) + '%' : '—'}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

function EmptyBlock({ title, msg }) {
  return (
    <div style={{ background: 'var(--bg-table)', border: '1px solid var(--border-light)', borderRadius: 12, padding: '14px 16px' }}>
      {title && <div style={{ fontSize: 12, color: 'var(--text-sub)', marginBottom: 10, letterSpacing: '0.05em', textTransform: 'uppercase' }}>{title}</div>}
      <div style={{ height: 120, display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'var(--text-muted)', fontSize: 12 }}>{msg}</div>
    </div>
  );
}
